/**
 * Channel Bar Chart Component
 * არხების ჰორიზონტალური ჩარტი
 */

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

interface ChannelBarChartProps {
  data: Record<string, number>;
  title: string;
  height?: number;
}

const COLORS: Record<string, string> = {
  WEB: '#6366f1',
  TELEGRAM: '#0088cc',
  WHATSAPP: '#25d366',
  VIBER: '#7360f2',
  MESSENGER: '#0084ff',
  INSTAGRAM: '#e1306c',
};

export default function ChannelBarChart({
  data,
  title,
  height = 300,
}: ChannelBarChartProps) {
  const chartData = Object.entries(data).map(([name, value]) => ({
    name,
    value,
  }));

  return (
    <div>
      <h3 className="text-sm font-medium text-gray-600 mb-4">{title}</h3>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={chartData} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis type="number" tick={{ fill: '#6b7280', fontSize: 12 }} />
          <YAxis
            type="category"
            dataKey="name"
            tick={{ fill: '#6b7280', fontSize: 12 }}
            width={100}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
            }}
          />
          <Bar dataKey="value" radius={[0, 4, 4, 0]}>
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[entry.name] || '#6366f1'}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
